import * as React from 'react';
import Utils from '../../../../utils';
import { SearchDriveItemState } from '../../../../containers/DriveItemList/Search/reducer';
import { SearchFieldContainer, ButtonIcon, SearchFieldInput, SearchFieldBar } from './styles';
import RoutesUtils from '../../../../utils/routes';
import { DriveItemListOrigin } from '../../../../containers/DriveItemListPage/constants';
const I18n = require('react-redux-i18n').I18n;

interface SearchFieldProps {
	searchText?: string;
	search: SearchDriveItemState;
	innerRef: React.RefObject<HTMLInputElement>;
}

interface SearchFieldState {
	searchText: string;
}

class SearchField extends React.Component<SearchFieldProps, SearchFieldState> {

	constructor(props: SearchFieldProps) {
		super(props);
		this.handleClickClear = this.handleClickClear.bind(this);
		this.handleSendForm = this.handleSendForm.bind(this);
		this.handleSearchTextChange = this.handleSearchTextChange.bind(this);
		this.state = { searchText: this.props.searchText || '' };
	}

	componentWillReceiveProps(nextProps: SearchFieldProps) {
		if (this.props.searchText !== nextProps.searchText) {
			this.setState({ searchText: nextProps.searchText || '' });
		}
	}

	render() {
		const { innerRef } = this.props;
		const { searchText } = this.state;

		return (
			<SearchFieldContainer>
				<SearchFieldBar onSubmit={this.handleSendForm} >
					<ButtonIcon type="submit" isLeft={true}>
						{Utils.getSvgIcon('iconset_uprez_menu_search')}
					</ButtonIcon>
					<SearchFieldInput
						ref={innerRef}
						value={searchText}
						onChange={this.handleSearchTextChange}
						placeholder={I18n.t('messages.placeholder_search_drive_item')}
						autoFocus={true}
					/>
					{searchText &&
						<ButtonIcon onClick={this.handleClickClear} isLeft={false}>
							{Utils.getSvgIcon('iconset_close_bar')}
						</ButtonIcon>
					}
				</SearchFieldBar>
			</SearchFieldContainer>
		);
	}

	private handleSendForm(e: React.FormEvent<HTMLFormElement>): void {
		const { innerRef } = this.props;
		e.preventDefault();
		window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Search, encodeURIComponent(this.state.searchText))}`;

		// to close keyboard on mobile devices after search results are displayed
		if (innerRef.current) {
			innerRef.current.blur();
		}
	}

	private handleClickClear(e: React.MouseEvent<HTMLButtonElement>): void {
		e.preventDefault();
		this.setState({ searchText: '' });
		window.location.hash = `#${RoutesUtils.getPathDriveItemListPage(DriveItemListOrigin.Search, null)}`;
	}

	private handleSearchTextChange(e: React.FormEvent<HTMLInputElement>): void {
		this.setState({ searchText: e.currentTarget.value });
	}
}

export default React.forwardRef<HTMLInputElement, SearchFieldProps>((props, ref) => (
	<SearchField
		innerRef={ref}
		{...props}
	/>
));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/Search/Field/index.tsx